import React, { useEffect, useState } from 'react';
import {
    Box, Typography, Card, Grid, Chip,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, CircularProgress, Alert, IconButton, useTheme, Tooltip,
    Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField,
    Accordion, AccordionSummary, AccordionDetails
} from '@mui/material';
import Layout from './Layout';
import DownloadIcon from '@mui/icons-material/Download';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import EuroIcon from '@mui/icons-material/Euro';
import PaymentsIcon from '@mui/icons-material/Payments';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import EmailIcon from '@mui/icons-material/Email';
import DeleteIcon from '@mui/icons-material/Delete';
const moment = require('moment');

const Fatture = () => {
    const [fatture, setFatture] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [openPayModal, setOpenPayModal] = useState(false);
    const [openSDIModal, setOpenSDIModal] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [paymentDate, setPaymentDate] = useState(moment().format('YYYY-MM-DD'));
    const [sdiData, setSDIData] = useState({ numero_sdi: '', anno_sdi: '', data_sdi: '' });
    const [notice, setNotice] = useState('');

    const theme = useTheme();

    const fetchFatture = () => {
        const token = localStorage.getItem('token');
        fetch('/papi2/invoices/fattura', {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        })
            .then(response => {
                if (!response.ok) {
                    if (response.status === 401 || response.status === 403) {
                        localStorage.removeItem('token');
                        window.location.href = '/login';
                    }
                    throw new Error('Errore nel caricamento delle fatture');
                }
                return response.json();
            })
            .then(data => {
                if (Array.isArray(data)) {
                    setFatture(data);
                } else {
                    console.error('API non ha restituito un array di fatture:', data);
                    setFatture([]);
                }
                setLoading(false);
            })
            .catch(err => {
                setError(err.message);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchFatture();
    }, []);

    const formatCurrency = (val) => new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(val);
    const formatDate = (d) => moment(d).format('DD/MM/YYYY');

    const handleDownload = (id) => {
        // Direct link to the download endpoint
        window.open(`/papi2/invoices/fattura/${id}/download`, '_blank');
    };

    const handleOpenPayModal = (invoice) => {
        setSelectedInvoice(invoice);
        setPaymentDate(moment().format('YYYY-MM-DD'));
        setOpenPayModal(true);
    };

    const handleOpenSDIModal = (invoice) => {
        setSelectedInvoice(invoice);
        setSDIData({
            numero_sdi: invoice.numero_sdi || '',
            anno_sdi: invoice.anno_sdi || '',
            data_sdi: invoice.data_sdi ? moment(invoice.data_sdi).format('YYYY-MM-DD') : ''
        });
        setOpenSDIModal(true);
    };

    const handleConfirmPayment = () => {
        if (!selectedInvoice) return;

        const token = localStorage.getItem('token');
        fetch(`/papi2/invoices/pagamenti/pagaFatturaPilota/${selectedInvoice.idfatturapilota}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ dataPagamento: paymentDate })
        })
            .then(response => {
                if (response.ok) {
                    setOpenPayModal(false);
                    fetchFatture(); // Refresh list
                } else {
                    alert("Errore durante il salvataggio del pagamento");
                }
            })
            .catch(err => console.error(err));
    };

    const handleConfirmSDI = () => {
        if (!selectedInvoice) return;

        const token = localStorage.getItem('token');
        fetch(`/papi2/invoices/fattura/${selectedInvoice.idfatturapilota}/sdi`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(sdiData)
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setOpenSDIModal(false);
                    fetchFatture(); // Refresh list
                } else {
                    alert("Errore durante il salvataggio dei dati SDI");
                }
            })
            .catch(err => console.error(err));
    };

    const handleSendEmail = (idFattura) => {
        if (!idFattura) return;
        const token = localStorage.getItem('token');
        fetch(`/papi2/invoices/email-invoice/${idFattura}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        })
            .then(async response => {
                const data = await response.json().catch(() => ({}));
                if (response.ok) {
                    alert("Email inviata con successo");
                    fetchFatture(); // Refresh list to see updated status
                } else {
                    alert(data.error || "Errore durante l'invio dell'email");
                }
            })
            .catch(err => {
                console.error(err);
                alert("Errore di rete durante l'invio dell'email");
            });
    };


    const handleDelete = (invoice) => {
        if (!invoice || invoice.numero_sdi) {
            setNotice('La fattura ha già un SDI assegnato e non può essere eliminata.');
            return;
        }
        if (!window.confirm(`Eliminare la fattura n. ${invoice.numerofattura}?\nLe attività associate torneranno fatturabili.`)) return;

        const token = localStorage.getItem('token');
        fetch(`/papi2/invoices/fattura/${invoice.idfatturapilota}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json',
            },
        })
            .then(response => {
                if (response.ok) {
                    setNotice('Fattura eliminata con successo. Le attività torneranno fatturabili.');
                    fetchFatture();
                } else if (response.status === 404) {
                    setNotice('Fattura non trovata.');
                } else {
                    return response.json().then(d => { throw new Error(d.error || 'Errore durante l\'eliminazione'); });
                }
            })
            .catch(err => {
                console.error(err);
                setNotice(`Errore durante l'eliminazione: ${err.message}`);
            });
    };

    // Group invoices by year
    const invoicesByYear = fatture.reduce((acc, curr) => {
        const year = curr.annofattura;
        if (!acc[year]) acc[year] = [];
        acc[year].push(curr);
        return acc;
    }, {});

    const sortedYears = Object.keys(invoicesByYear).sort((a, b) => b - a);

    const getYearStats = (yearInvoices) => {
        const invoiced = yearInvoices.reduce((acc, curr) => acc + (curr.fattimporto || 0), 0);
        const paid = yearInvoices.reduce((acc, curr) => acc + (curr.totalepagato || 0), 0);
        const toPay = yearInvoices.reduce((acc, curr) => acc + (curr.importodapagare || 0), 0);
        return { invoiced, paid, toPay };
    };

    const StatCard = ({ title, value, color, icon }) => (
        <Card
            elevation={3}
            sx={{
                p: 2,
                borderRadius: 3,
                background: 'rgba(255,255,255,0.8)',
                backdropFilter: 'blur(12px)',
                border: '1px solid rgba(255,255,255,0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            }}
        >
            <Box>
                <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase">
                    {title}
                </Typography>
                <Typography variant="h6" color={color} fontWeight={700}>
                    {formatCurrency(value)}
                </Typography>
            </Box>
            <Box sx={{ p: 1, borderRadius: '50%', bgcolor: `${color}20`, color: color }}>
                {icon}
            </Box>
        </Card>
    );

    return (
        <Layout>
            <Box sx={{ p: { xs: 2, md: 4 } }}>
                <Typography variant="h4" fontWeight={800} gutterBottom sx={{
                    background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    mb: 4
                }}>
                    Riepilogo Fatture (per Anno)
                </Typography>

                {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
                {notice && (
                    <Alert severity="info" sx={{ mb: 3 }} onClose={() => setNotice('')}>{notice}</Alert>
                )}

                {loading ? (
                    <Box p={5} textAlign="center"><CircularProgress /></Box>
                ) : (
                    sortedYears.map((year, index) => {
                        const yearInvoices = invoicesByYear[year];
                        const stats = getYearStats(yearInvoices);

                        return (
                            <Accordion key={year} defaultExpanded={index === 0} sx={{ mb: 2, borderRadius: 2, '&:before': { display: 'none' } }}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    sx={{
                                        bgcolor: theme.palette.primary.main,
                                        color: 'white',
                                        borderRadius: 2,
                                        '&:hover': { bgcolor: theme.palette.primary.dark }
                                    }}
                                >
                                    <Box display="flex" alignItems="center" width="100%" justifyContent="space-between" pr={2}>
                                        <Typography variant="h5" fontWeight={700}>
                                            Anno {year}
                                        </Typography>
                                        <Box display="flex" gap={3}>
                                            <Box textAlign="center">
                                                <Typography variant="caption" sx={{ opacity: 0.9 }}>Fatturato</Typography>
                                                <Typography variant="h6" fontWeight={700}>{formatCurrency(stats.invoiced)}</Typography>
                                            </Box>
                                            <Box textAlign="center">
                                                <Typography variant="caption" sx={{ opacity: 0.9 }}>Incassato</Typography>
                                                <Typography variant="h6" fontWeight={700}>{formatCurrency(stats.paid)}</Typography>
                                            </Box>
                                            <Box textAlign="center">
                                                <Typography variant="caption" sx={{ opacity: 0.9 }}>Da Saldare</Typography>
                                                {stats.toPay > 0 && (
                                                    <Typography variant="h6" fontWeight={700} color="error">{formatCurrency(stats.toPay)}</Typography>
                                                )}
                                                {stats.toPay === 0 && (
                                                    <Typography variant="h6" fontWeight={700} >{formatCurrency(stats.toPay)}</Typography>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>
                                </AccordionSummary>
                                <AccordionDetails sx={{ p: 0 }}>
                                    <TableContainer>
                                        <Table>
                                            <TableHead sx={{ bgcolor: 'rgba(0,0,0,0.03)' }}>
                                                <TableRow>
                                                    <TableCell><Typography fontWeight={700}>Numero</Typography></TableCell>
                                                    <TableCell><Typography fontWeight={700}>Data</Typography></TableCell>
                                                    <TableCell><Typography fontWeight={700}>Cliente</Typography></TableCell>
                                                    <TableCell align="right"><Typography fontWeight={700}>Importo</Typography></TableCell>
                                                    <TableCell align="center"><Typography fontWeight={700}>Stato</Typography></TableCell>
                                                    <TableCell align="center"><Typography fontWeight={700}>Pdf</Typography></TableCell>
                                                    <TableCell align="center"><Typography fontWeight={700}>Pagamento</Typography></TableCell>
                                                    <TableCell align="center"><Typography fontWeight={700}>SDI</Typography></TableCell>
                                                    <TableCell align="center"><Typography fontWeight={700}>Azioni</Typography></TableCell>

                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {yearInvoices.map((row) => (
                                                    <TableRow key={row.idfatturapilota} hover>
                                                        <TableCell>
                                                            <Chip label={row.numerofattura} size="small" sx={{ fontWeight: 'bold' }} />
                                                        </TableCell>
                                                        <TableCell>{formatDate(row.datafattura)}</TableCell>
                                                        <TableCell sx={{ fontWeight: 500 }}>{row.ragionesociale}</TableCell>
                                                        <TableCell align="right" sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>
                                                            {formatCurrency(row.fattimporto)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.statofattura === 0 && <Chip label="Bozza" size="small" />}
                                                            {row.statofattura === 1 && (
                                                                <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                                                                    <Chip label="Emessa" color="primary" size="small" />
                                                                    <Tooltip title="Invia Email">
                                                                        <IconButton onClick={() => handleSendEmail(row.idfatturapilota)} color="primary" size="small">
                                                                            <EmailIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </Box>
                                                            )}
                                                            {row.statofattura === 2 && <Chip label="Inviata" color="info" size="small" />}
                                                            {row.statofattura === 3 && <Chip label="Pagata" color="success" size="small" />}
                                                            {row.statofattura === 5 && <Chip label="Registrata" color="success" size="small" variant="filled" />}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Tooltip title="Scarica PDF">
                                                                <IconButton onClick={() => handleDownload(row.idfatturapilota)} color="primary" size="small">
                                                                    <DownloadIcon />
                                                                </IconButton>
                                                            </Tooltip>

                                                        </TableCell>


                                                        <TableCell align="center">
                                                            {row.importodapagare > 0 ? (
                                                                <Chip label="Non Saldato" color="error" size="small" variant="outlined" />
                                                            ) : (
                                                                <Chip label="Saldato" color="success" size="small" variant="outlined" />
                                                            )}
                                                            {row.importodapagare > 0 && (
                                                                <Tooltip title="Segna come Pagata">
                                                                    <IconButton onClick={() => handleOpenPayModal(row)} color="success" size="small">
                                                                        <PaymentsIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.numero_sdi && row.anno_sdi ? (
                                                                <Box
                                                                    sx={{
                                                                        display: 'inline-flex',
                                                                        flexDirection: 'row',
                                                                        alignItems: 'center',
                                                                        gap: 1,
                                                                        bgcolor: '#FFFDE7',
                                                                        border: '1.5px solid #FBC02D',
                                                                        borderRadius: '20px',
                                                                        px: 2,
                                                                        py: 0.75,
                                                                        cursor: 'pointer',
                                                                        transition: 'all 0.2s',
                                                                        '&:hover': {
                                                                            transform: 'scale(1.05)',
                                                                            boxShadow: 2,
                                                                            bgcolor: '#FFF9C4'
                                                                        }
                                                                    }}
                                                                    onClick={() => handleOpenSDIModal(row)}
                                                                >
                                                                    <WorkspacePremiumIcon sx={{ color: '#FBC02D', fontSize: 26 }} />
                                                                    <Typography variant="body1" fontWeight={800} sx={{ color: '#AF8B00', lineHeight: 1 }}>
                                                                        {row.numero_sdi}/{row.anno_sdi}
                                                                    </Typography>
                                                                    {row.data_sdi && (
                                                                        <Typography variant="caption" sx={{ color: '#AF8B00', ml: 1, fontWeight: 600 }}>
                                                                            {formatDate(row.data_sdi)}
                                                                        </Typography>
                                                                    )}
                                                                </Box>
                                                            ) : (
                                                                <Button
                                                                    variant="outlined"
                                                                    size="small"
                                                                    startIcon={<ReceiptLongIcon />}
                                                                    onClick={() => handleOpenSDIModal(row)}
                                                                    sx={{ fontSize: '0.7rem', py: 0.5 }}
                                                                >
                                                                    Fatt. Elettronica
                                                                </Button>
                                                            )}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Tooltip title={row.numero_sdi ? 'Fattura con SDI assegnato' : 'Elimina fattura'}> 
                                                                <IconButton
                                                                    onClick={() => handleDelete(row)}
                                                                    disabled={!!row.numero_sdi}
                                                                    color="error"
                                                                    size="small"
                                                                >
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>

                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </AccordionDetails>
                            </Accordion>
                        );
                    })
                )}

                {/* Dialogs */}
                <Dialog open={openPayModal} onClose={() => setOpenPayModal(false)}>
                    <DialogTitle>Segna come Pagata</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Data Pagamento"
                            type="date"
                            fullWidth
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            value={paymentDate}
                            onChange={(e) => setPaymentDate(e.target.value)}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenPayModal(false)}>Annulla</Button>
                        <Button onClick={handleConfirmPayment} variant="contained" color="success">
                            Conferma Pagamento
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* SDI Modal */}
                <Dialog open={openSDIModal} onClose={() => setOpenSDIModal(false)} maxWidth="sm" fullWidth>
                    <DialogTitle>
                        <Box display="flex" alignItems="center" gap={1}>
                            <ReceiptLongIcon color="primary" />
                            <Typography variant="h6">Fatturazione Elettronica - SDI</Typography>
                        </Box>
                    </DialogTitle>
                    <DialogContent>
                        <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <TextField
                                label="Numero SDI"
                                type="number"
                                fullWidth
                                variant="outlined"
                                value={sdiData.numero_sdi}
                                onChange={(e) => setSDIData({ ...sdiData, numero_sdi: e.target.value })}
                                InputLabelProps={{ shrink: true }}
                            />
                            <TextField
                                label="Anno SDI"
                                type="number"
                                fullWidth
                                variant="outlined"
                                value={sdiData.anno_sdi}
                                onChange={(e) => setSDIData({ ...sdiData, anno_sdi: e.target.value })}
                                InputLabelProps={{ shrink: true }}
                            />
                            <TextField
                                label="Data SDI"
                                type="date"
                                fullWidth
                                variant="outlined"
                                value={sdiData.data_sdi}
                                onChange={(e) => setSDIData({ ...sdiData, data_sdi: e.target.value })}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenSDIModal(false)}>Annulla</Button>
                        <Button onClick={handleConfirmSDI} variant="contained" color="primary" startIcon={<ReceiptLongIcon />}>
                            Salva Dati SDI
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
            {!loading && fatture.length === 0 && (
                <Box textAlign="center" py={5}>
                    <Typography color="text.secondary">Nessuna fattura trovata.</Typography>
                </Box>
            )}

        </Layout>
    );
};

export default Fatture;
